export default {
  model: 'detailed',
  cards: {
    1: { value: '1*1' },
    2: { value: '4/2' },
    3: { value: '1+2' },
    4: { value: '2*2' },
    5: { value: '7-2' },
    6: { value: '2*3' },
    7: { value: '4+3' },
    8: { value: '4*2' },
    9: { value: '3*3' },
    10: { value: '5+5' }
  }
};
